import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Chip,
  Divider,
  Tabs,
  Tab,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Grid,
  Paper,
  Switch,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Alert,
  CircularProgress,
  Tooltip,
  Autocomplete,
  FormGroup,
} from "@mui/material";
import {
  EmojiEvents as TrophyIcon,
  Email as EmailIcon,
  Close as CloseIcon,
  Send as SendIcon,
  Group as GroupIcon,
  Person as PersonIcon,
  Edit as EditIcon,
  Preview as PreviewIcon,
  ExpandMore as ExpandMoreIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Save as SaveIcon,
} from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { sendWinnerNotifications } from "../../store/slices/notificationsSlice";
import { toast } from "react-toastify";

const WinnerNotificationDialog = ({ open, onClose, winner, giveaway }) => {
  const dispatch = useDispatch();
  const { members, totalMembers } = useSelector((state) => state.members);

  const [activeTab, setActiveTab] = useState(0);
  const [emailTemplate, setEmailTemplate] = useState({
    subject: "Congratulations! You've Won the {{giveaway_name}}",
    body: `<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #f8f9fa;">
  <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 30px; text-align: center; border-radius: 10px 10px 0 0;">
    <h1 style="color: white; margin: 0; font-size: 28px;">🎉 Congratulations! 🎉</h1>
  </div>
  
  <div style="background: white; padding: 30px; border-radius: 0 0 10px 10px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
    <h2 style="color: #333; margin-bottom: 20px;">Dear {{winner_name}},</h2>
    
    <p style="font-size: 16px; line-height: 1.6; color: #555;">We're thrilled to announce that you've won our <strong>{{giveaway_name}}</strong> giveaway!</p>
    
    <div style="background: #e8f5e8; padding: 20px; border-radius: 8px; margin: 20px 0; border-left: 4px solid #4caf50;">
      <h3 style="color: #2e7d32; margin: 0 0 10px 0;">Prize Details:</h3>
      <p style="margin: 0; font-size: 16px; color: #333;"><strong>{{prize_description}}</strong></p>
    </div>
    
    <h3 style="color: #333; margin-top: 25px;">Next Steps:</h3>
    <div style="text-align: center; margin: 30px 0;">
      <a href="{{claim_url}}" style="display: inline-block; background: linear-gradient(135deg, #4caf50 0%, #45a049 100%); color: white; padding: 15px 30px; text-decoration: none; border-radius: 25px; font-weight: bold; font-size: 16px; box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3); transition: all 0.3s ease;">🎁 Claim Your Prize Now</a>
    </div>
    <p style="color: #555; line-height: 1.6; text-align: center; font-size: 14px;">Click the button above to claim your prize, or copy and paste this link into your browser:<br><span style="color: #007bff; word-break: break-all;">{{claim_url}}</span></p>
    
    <h4 style="color: #333; margin-top: 25px;">After claiming:</h4>
    <ol style="color: #555; line-height: 1.6;">
      <li>Provide your shipping address and contact information</li>
      <li>We'll process and ship your prize within 5-10 business days</li>
    </ol>
    
    <div style="background: #fff3cd; padding: 15px; border-radius: 8px; margin: 20px 0; border-left: 4px solid #ffc107;">
      <p style="margin: 0; color: #856404;"><strong>Important:</strong> You have 7 days from the date of this email to claim your prize. Unclaimed prizes will be forfeited.</p>
    </div>
    
    <p style="color: #555; line-height: 1.6;">Thank you for being a valued member of Nature's Perks! We hope you enjoy your prize.</p>
    
    <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #eee;">
      <p style="color: #888; margin: 0;">Best regards,<br><strong>The Nature's Perks Team</strong></p>
    </div>
  </div>
</div>`,
  });

  const [bulkEmailSettings, setBulkEmailSettings] = useState({
    sendToWinner: true,
    sendToAllMembers: false,
    sendToGroups: [],
    customRecipients: [],
    subject: "Exciting News: {{giveaway_name}} Winner Announced!",
    body: `<div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; background-color: #f8f9fa;">
  <div style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 30px; text-align: center; border-radius: 10px 10px 0 0;">
    <h1 style="color: white; margin: 0; font-size: 28px;">🎉 Winner Announcement! 🎉</h1>
  </div>
  
  <div style="background: white; padding: 30px; border-radius: 0 0 10px 10px; box-shadow: 0 4px 6px rgba(0,0,0,0.1);">
    <h2 style="color: #333; margin-bottom: 20px;">Dear Nature's Perks Member,</h2>
    
    <p style="font-size: 16px; line-height: 1.6; color: #555;">We're excited to announce the winner of our <strong>{{giveaway_name}}</strong> giveaway!</p>
    
    <div style="background: #e3f2fd; padding: 20px; border-radius: 8px; margin: 20px 0; border-left: 4px solid #2196f3; text-align: center;">
      <h3 style="color: #1976d2; margin: 0 0 10px 0;">🏆 Congratulations to:</h3>
      <p style="margin: 0; font-size: 20px; font-weight: bold; color: #333;">{{winner_name}}</p>
    </div>
    
    <div style="background: #e8f5e8; padding: 20px; border-radius: 8px; margin: 20px 0; border-left: 4px solid #4caf50;">
      <h3 style="color: #2e7d32; margin: 0 0 10px 0;">Prize Won:</h3>
      <p style="margin: 0; font-size: 16px; color: #333;"><strong>{{prize_description}}</strong></p>
    </div>
    
    <p style="color: #555; line-height: 1.6;">Don't worry if you didn't win this time - we have more exciting giveaways coming up! Keep an eye on your email for future opportunities.</p>
    
    <div style="text-align: center; margin: 20px 0;">
      <a href="#" style="background: #4caf50; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; display: inline-block; font-weight: bold;">View Upcoming Giveaways</a>
    </div>
    
    <div style="text-align: center; margin-top: 30px; padding-top: 20px; border-top: 1px solid #eee;">
      <p style="color: #888; margin: 0;">Thank you for being part of Nature's Perks!<br><strong>The Nature's Perks Team</strong></p>
    </div>
  </div>
</div>`,
  });

  const [memberGroups, setMemberGroups] = useState([
    { id: 1, name: "Gold Members", members: [], criteria: { tier: "gold" } },
    {
      id: 2,
      name: "Silver Members",
      members: [],
      criteria: { tier: "silver" },
    },
    {
      id: 3,
      name: "Active Members",
      members: [],
      criteria: { status: "active" },
    },
  ]);

  const [newGroup, setNewGroup] = useState({ name: "", criteria: {} });
  const [showNewGroupForm, setShowNewGroupForm] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [previewMode, setPreviewMode] = useState(0);
  const [sending, setSending] = useState(false);

  // Load members into groups based on criteria
  useEffect(() => {
    if (members && members.length > 0) {
      const updatedGroups = memberGroups.map((group) => {
        const filteredMembers = members.filter((member) => {
          if (group.criteria.tier && member.tier !== group.criteria.tier)
            return false;
          if (group.criteria.status && member.status !== group.criteria.status)
            return false;
          return true;
        });
        return { ...group, members: filteredMembers };
      });
      setMemberGroups(updatedGroups);
    }
  }, [members]);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const handleTabEmailViewChange = (event, newValue) => {
    setPreviewMode(newValue);
  };

  const handleTemplateChange = (field, value) => {
    setEmailTemplate((prev) => ({ ...prev, [field]: value }));
  };

  const handleBulkEmailChange = (field, value) => {
    setBulkEmailSettings((prev) => ({ ...prev, [field]: value }));
  };

  const handleGroupToggle = (groupId) => {
    setBulkEmailSettings((prev) => ({
      ...prev,
      sendToGroups: prev.sendToGroups.includes(groupId)
        ? prev.sendToGroups.filter((id) => id !== groupId)
        : [...prev.sendToGroups, groupId],
    }));
  };

  const handleCreateGroup = () => {
    if (newGroup.name.trim()) {
      const newGroupObj = {
        id: Date.now(),
        name: newGroup.name,
        members: selectedMembers,
        criteria: newGroup.criteria,
      };
      setMemberGroups((prev) => [...prev, newGroupObj]);
      setNewGroup({ name: "", criteria: {} });
      setSelectedMembers([]);
      setShowNewGroupForm(false);
      toast.success("Member group created successfully!");
    }
  };

  const handleDeleteGroup = (groupId) => {
    setMemberGroups((prev) => prev.filter((group) => group.id !== groupId));
    setBulkEmailSettings((prev) => ({
      ...prev,
      sendToGroups: prev.sendToGroups.filter((id) => id !== groupId),
    }));
    toast.success("Member group deleted successfully!");
  };

  const replaceTemplateVariables = (template, isWinnerEmail = false) => {
    let processedTemplate = template;

    const variables = {
      giveaway_name: giveaway?.title || "Monthly Giveaway",
      winner_name:
        winner?.name ||
        winner?.first_name + " " + winner?.last_name ||
        "Winner",
      prize_description: giveaway?.prize || "Amazing Prize Package",
      draw_date: giveaway?.draw_date
        ? new Date(giveaway.draw_date).toLocaleDateString()
        : new Date().toLocaleDateString(),
      member_name: isWinnerEmail ? winner?.name || "Member" : "{{member_name}}",
    };

    Object.keys(variables).forEach((key) => {
      const regex = new RegExp(`{{${key}}}`, "g");
      processedTemplate = processedTemplate.replace(regex, variables[key]);
    });

    return processedTemplate;
  };

  const handleSendEmails = async () => {
    setSending(true);
    try {
      const emailData = {
        winner: winner,
        giveaway: giveaway,
        winnerEmail: {
          subject: replaceTemplateVariables(emailTemplate.subject, true),
          body: replaceTemplateVariables(emailTemplate.body, true),
        },
        bulkEmail: {
          subject: replaceTemplateVariables(bulkEmailSettings.subject),
          body: replaceTemplateVariables(bulkEmailSettings.body),
          sendToWinner: bulkEmailSettings.sendToWinner,
          sendToAllMembers: bulkEmailSettings.sendToAllMembers,
          sendToGroups: bulkEmailSettings.sendToGroups,
          customRecipients: bulkEmailSettings.customRecipients,
        },
        memberGroups: memberGroups,
      };

      // Here you would make an API call to send the emails
      await dispatch(sendWinnerNotifications(emailData));

      // For now, simulate the API call
      await new Promise((resolve) => setTimeout(resolve, 2000));

      toast.success("Emails sent successfully!");
      onClose();
    } catch (error) {
      toast.error("Failed to send emails. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const getRecipientCount = () => {
    let count = 0;
    if (bulkEmailSettings.sendToWinner) count += 1;
    if (bulkEmailSettings.sendToAllMembers) {
      // Use actual participants in the giveaway, excluding the winner
      const participantCount = giveaway?.total_participants || 0;
      count += Math.max(0, participantCount - 1);
    }

    // bulkEmailSettings.sendToGroups.forEach((groupId) => {
    //   const group = memberGroups.find((g) => g.id === groupId);
    //   if (group) count += group.members.length;
    // });

    count += bulkEmailSettings.customRecipients.length;
    return count;
  };

  if (!winner || !giveaway) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: { height: "90vh" },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TrophyIcon color="primary" sx={{ mr: 1 }} />
            Winner Notification Center
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab icon={<PersonIcon />} label="Winner Details" />
            <Tab icon={<EmailIcon />} label="Winner Email" />
            <Tab icon={<GroupIcon />} label="Bulk Email" />
            <Tab icon={<PreviewIcon />} label="Preview & Send" />
          </Tabs>
        </Box>

        <Box sx={{ p: 3, height: "calc(90vh - 200px)", overflow: "auto" }}>
          {/* Winner Details Tab */}
          {activeTab === 0 && (
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <Card elevation={3}>
                  <CardContent sx={{ textAlign: "center" }}>
                    <Avatar
                      src={winner?.avatar_url}
                      sx={{ width: 100, height: 100, mx: "auto", mb: 2 }}
                    >
                      {winner?.first_name?.charAt(0) || "W"}
                    </Avatar>
                    <Typography variant="h5" gutterBottom>
                      {winner?.name ||
                        winner?.first_name + " " + winner?.last_name}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                    >
                      {winner?.email || winner?.email}
                    </Typography>
                    <Chip
                      label={`${winner?.plan_name || "Member"}`}
                      color="primary"
                      sx={{ mt: 1 }}
                    />
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6" gutterBottom>
                      Giveaway Details
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Title:</strong> {giveaway?.title}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Prize:</strong> {giveaway?.prize}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Draw Date:</strong>{" "}
                      {giveaway?.draw_date
                        ? new Date(giveaway.draw_date).toLocaleDateString()
                        : "N/A"}
                    </Typography>
                    {/* <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Entries Used:</strong> {winner?.entries_used}
                    </Typography>
                    <Typography variant="body2">
                      <strong>Remaining Entries:</strong>{" "}
                      {winner?.remaining_entries || 0}
                    </Typography> */}
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}

          {/* Winner Email Tab */}
          {activeTab === 1 && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Winner Notification Email
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email Subject"
                    value={emailTemplate.subject}
                    onChange={(e) =>
                      handleTemplateChange("subject", e.target.value)
                    }
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email Body (HTML)"
                    value={emailTemplate.body}
                    onChange={(e) =>
                      handleTemplateChange("body", e.target.value)
                    }
                    multiline
                    rows={15}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Alert severity="info">
                    <strong>Available Variables:</strong> {"{"}giveaway_name
                    {"}"}, {"{"}winner_name{"}"}, {"{"}prize_description{"}"},{" "}
                    {"{"}draw_date{"}"}
                  </Alert>
                </Grid>
              </Grid>
            </Box>
          )}

          {/* Bulk Email Tab */}
          {activeTab === 2 && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Bulk Email Settings
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Paper sx={{ p: 2, mb: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Recipients
                    </Typography>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={bulkEmailSettings.sendToWinner}
                            onChange={(e) =>
                              handleBulkEmailChange(
                                "sendToWinner",
                                e.target.checked
                              )
                            }
                          />
                        }
                        label="Send to Winner"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={bulkEmailSettings.sendToAllMembers}
                            onChange={(e) =>
                              handleBulkEmailChange(
                                "sendToAllMembers",
                                e.target.checked
                              )
                            }
                          />
                        }
                        label={`Send to Giveaway Participants (${Math.max(0, (giveaway?.total_participants || 0) - 1)})`}
                      />
                    </FormGroup>

                    {/* <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
                      Member Groups
                    </Typography>
                    {memberGroups.map((group) => (
                      <Box
                        key={group.id}
                        sx={{ display: "flex", alignItems: "center", mb: 1 }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={bulkEmailSettings.sendToGroups.includes(
                                group.id
                              )}
                              onChange={() => handleGroupToggle(group.id)}
                            />
                          }
                          label={`${group.name} (${group.members.length})`}
                          sx={{ flexGrow: 1 }}
                        />
                        <IconButton
                          size="small"
                          onClick={() => handleDeleteGroup(group.id)}
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    ))} */}

                    {/* {!showNewGroupForm ? (
                      <Button
                        startIcon={<AddIcon />}
                        onClick={() => setShowNewGroupForm(true)}
                        size="small"
                      >
                        Create New Group
                      </Button>
                    ) : (
                      <Box
                        sx={{
                          mt: 2,
                          p: 2,
                          border: "1px solid #ddd",
                          borderRadius: 1,
                        }}
                      >
                        <TextField
                          fullWidth
                          size="small"
                          label="Group Name"
                          value={newGroup.name}
                          onChange={(e) =>
                            setNewGroup((prev) => ({
                              ...prev,
                              name: e.target.value,
                            }))
                          }
                          sx={{ mb: 2 }}
                        />
                        <Autocomplete
                          multiple
                          options={members || []}
                          getOptionLabel={(option) =>
                            `${option.display_name} (${option.user_email})`
                          }
                          value={selectedMembers}
                          onChange={(event, newValue) =>
                            setSelectedMembers(newValue)
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              label="Select Members"
                              placeholder="Choose members for this group"
                            />
                          )}
                          sx={{ mb: 2 }}
                        />
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Button
                            size="small"
                            variant="contained"
                            onClick={handleCreateGroup}
                            startIcon={<SaveIcon />}
                          >
                            Save Group
                          </Button>
                          <Button
                            size="small"
                            onClick={() => {
                              setShowNewGroupForm(false);
                              setNewGroup({ name: "", criteria: {} });
                              setSelectedMembers([]);
                            }}
                          >
                            Cancel
                          </Button>
                        </Box>
                      </Box>
                    )} */}
                  </Paper>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Paper sx={{ p: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Email Template
                    </Typography>
                    <TextField
                      fullWidth
                      label="Subject"
                      value={bulkEmailSettings.subject}
                      onChange={(e) =>
                        handleBulkEmailChange("subject", e.target.value)
                      }
                      margin="normal"
                      size="small"
                    />
                    <TextField
                      fullWidth
                      label="Email Body (HTML)"
                      value={bulkEmailSettings.body}
                      onChange={(e) =>
                        handleBulkEmailChange("body", e.target.value)
                      }
                      multiline
                      rows={10}
                      margin="normal"
                      size="small"
                    />
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          )}

          {/* Preview & Send Tab */}
          {activeTab === 3 && (
            <Box>
              <Typography variant="h6" gutterBottom>
                Preview & Send Emails
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <Paper sx={{ p: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Email Summary
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Total Recipients:</strong> {getRecipientCount()}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Winner Email:</strong>{" "}
                      {bulkEmailSettings.sendToWinner ? "Yes" : "No"}
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>All Members:</strong>{" "}
                      {bulkEmailSettings.sendToAllMembers ? "Yes" : "No"}
                    </Typography>
                    {/* <Typography variant="body2" sx={{ mb: 1 }}>
                      <strong>Selected Groups:</strong>{" "}
                      {bulkEmailSettings.sendToGroups.length}
                    </Typography> */}

                    <Divider sx={{ my: 2 }} />

                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      startIcon={
                        sending ? <CircularProgress size={20} /> : <SendIcon />
                      }
                      onClick={handleSendEmails}
                      disabled={sending || getRecipientCount() === 0}
                      size="large"
                    >
                      {sending ? "Sending..." : "Send Emails"}
                    </Button>
                  </Paper>
                </Grid>

                <Grid item xs={12} md={8}>
                  <Paper sx={{ p: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <Typography variant="subtitle1" sx={{ flexGrow: 1 }}>
                        Email Preview
                      </Typography>
                      <Tabs
                        value={previewMode}
                        onChange={handleTabEmailViewChange}
                        sx={{ bgcolor: "background.paper" }}
                      >
                        <Tab label="Participant Email" />
                        <Tab label="Winner Email" />
                      </Tabs>
                    </Box>

                    <Box
                      sx={{
                        border: "1px solid #ddd",
                        borderRadius: 1,
                        p: 2,
                        minHeight: 400,
                      }}
                    >
                      <Typography variant="subtitle2" gutterBottom>
                        Subject:{" "}
                        {replaceTemplateVariables(
                          previewMode
                            ? emailTemplate.subject
                            : bulkEmailSettings.subject,
                          previewMode
                        )}
                      </Typography>
                      <Divider sx={{ mb: 2 }} />
                      <Box
                        dangerouslySetInnerHTML={{
                          __html: replaceTemplateVariables(
                            previewMode
                              ? emailTemplate.body
                              : bulkEmailSettings.body,
                            previewMode
                          ),
                        }}
                      />
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WinnerNotificationDialog;
